import { Box } from '@mui/material'
import { useApplicationRoleDefinitions, useTargetPerson } from 'hooks'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { ProtectedApplicationAssignmentInfo } from '../AssignmentTile'

const take = 3

export type ApplicationRoleDefinitionsProps = {
    applicationId: string
    applicationsType: any
    applicationTypeRegistry: any
    setShowSpacer: any
}

export const ApplicationRoleDefinitions: FC<ApplicationRoleDefinitionsProps> = (
    props: ApplicationRoleDefinitionsProps,
) => {
    const [page, setPage] = useState(1)
    const {
        applicationId,
        applicationsType,
        applicationTypeRegistry,
        setShowSpacer,
    } = props
    const { t } = useTranslation()
    const [targetPerson] = useTargetPerson()

    const { data, isLoading } = useApplicationRoleDefinitions(
        applicationId,
        targetPerson.id,
        (page - 1) * take,
        take,
    )
    const pageCount = data?.totalCount ? Math.ceil(data.totalCount / take) : 0

    const bindAppRoles = () => {
        try {
            if (data?.data?.length) {
                return data.data.map((item: any) => {
                    return {
                        resource: {
                            ...item,
                            id: item?.azLocalRoleId,
                            description:
                                item?.description || item.assignmentPointName,
                            manageAccessId: item?.id
                        },
                        assignment: {
                            personId: targetPerson.id,
                            isAssigned: item.isAssigned,
                            canActivateNow: item.canActivateNow,
                            isRenewable: item.isRenewable,
                            assignmentId: item?.id,
                            resourceAssignment: {
                                id: item.applicationId,
                                friendlyName: item.assignmentPointName,
                                resourceAssignmentId: item.azLocalRoleId,
                            },
                            assignmentDetails: {
                                timeConstraintActive: item.timeConstraintActive,
                                startDateUtc: item.startDateUtc,
                                endDateUtc: item.endDateUtc,
                                isRevokable: item.isRevocable,
                            },
                        },
                    }
                })
            }
        } catch (err) { }
        return []
    }

    useEffect(() => {
        if (data?.data?.length) {
            setShowSpacer(true)
        }
    }, [data])

    return (
        <Box>
            {isLoading ? (
                <Skeleton height={40} />
            ) : data?.data?.length ? (
                <Box>
                    <ProtectedApplicationAssignmentInfo
                        totalCount={data?.totalCount}
                        setPage={(value: any) => setPage(value)}
                        pageCount={pageCount}
                        resourceAssignment={bindAppRoles() || []}
                        title={t('Common_RoleDefinitions')}
                        resourceType={applicationsType}
                        manageAccessRedirectTab="roleDefinitions"
                        applicationId={applicationId}
                        applicationTypeRegistry={applicationTypeRegistry}
                    />
                </Box>
            ) : null}
        </Box>
    )
}
